import "./ProviderCategoryTabs.css";

export default function ProviderCategoryTabs({
  categories = [],
  selectedCategory,
  setSelectedCategory,
}) {
  return (
    <div className="provider-category-wrapper">
      <button
        className={
          selectedCategory === "All"
            ? "provider-category active"
            : "provider-category"
        }
        onClick={() => setSelectedCategory("All")}
      >
        All
      </button>

      {categories.map((category, index) => {
        const name =
          typeof category === "string"
            ? category
            : category?.name || "";

        return (
          <button
            key={`${name}-${index}`}
            className={
              selectedCategory === name
                ? "provider-category active"
                : "provider-category"
            }
            onClick={() => setSelectedCategory(name)}
          >
            {name}
          </button>
        );
      })}
    </div>
  );
}